import * as actionTypes from "./constants";

const initialState = {
  processing: false,
  error: false,
  loading: true,
};

export default function invoiecConfigReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_INVOICECONFIG_SUCCESS:
      console.log(action.payload.rows[0])
      return {
        ...state,
        loading: false,
        invoiceConfigList: action.payload.rows,
        invoiceConfigCount: action.payload.count,
      };
      case actionTypes.FETCH_INVOICECONFIG_INIT:
        return {
          ...state,
          loading: true,
        };
    default:
      return {
        ...state,
      };
  }
}
